import { style } from '@/styles/globals';
import { genLinkSeoForVexPage } from '@/utils/genLinkSeo';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { removeVietnameseTones } from '@/utils/stringConvert';
import { templateStr } from '@/utils/templateStr';
import { Stack, Link } from '@mui/material';
import { styled } from '@mui/system';
import { update } from 'lodash';
import { Airlines_Code, Airlines_Name } from './CompanyToRouteVcms';

const TitleContent = styled('div')`
  font-size: 1.5rem;
  font-weight: bold;
  vertical-align: bottom;
  display: inline-block;
  margin-bottom: 12px;
  padding-top: 12px;
  color: ${style.primary.black} !important; 
`;

export default function OtherCompanyFlightUrls({
  startPoint, toPoint, airlineSlug, showToOnly, block, lang,
}: any) {
  // const fromText = (airline?: string) => ` Vé máy bay ${airline} giá rẻ từ ${startPoint?.location} đi ${toPoint?.location}`;
  const fromText = (airline?: string) => (lang?.lang === 'en' ? templateStr('{{airlineName}} flight ticket from {{fromLocation}} to {{toLocation}}', {
    airlineName: airline,
    fromLocation: removeVietnameseTones(startPoint?.location),
    toLocation: removeVietnameseTones(toPoint?.location),
  }) : `Vé máy bay ${airline} giá rẻ từ ${startPoint?.location} đi ${toPoint?.location}`);

  // const toOnlyText = (airline?: string) => ` Vé máy bay ${airline} giá rẻ đi ${toPoint?.location}`;
  const toOnlyText = (airline?: string) => (lang?.lang === 'en' ? templateStr('{{airlineName}} flight ticket to {{toLocation}}', {
    airlineName: airline,
    toLocation: removeVietnameseTones(toPoint?.location),
  }) : ` Vé máy bay ${airline} giá rẻ đi ${toPoint?.location}`);
  const airlineCodeList = Object.keys(Airlines_Code).filter((code: any) => Airlines_Code[code] !== airlineSlug).map((airlineCode) => ({
    name: Airlines_Name[airlineCode],
    slug: Airlines_Code[airlineCode],
  }));

  const seoPageAffix = '/vcms/vex/vn';
  const fromLinkSeo = (airline: any) => ({
    startName: startPoint?.location,
    startId: startPoint?.id,
    startStateName: startPoint?.stateName,
    endName: toPoint?.location,
    endId: toPoint?.id,
    endStateName: toPoint?.stateName,
    company: airline || '',
    seoPageAffix,
    lang,
  });
  const toOnlyLinkSeo = (airline: any) => ({
    endName: toPoint?.location,
    endId: toPoint?.id,
    endStateName: toPoint?.stateName,
    company: airline || '',
    seoPageAffix,
    lang,
  });
  return (
    <>
      <TitleContent>
        {block?.headingContent?.title}
      </TitleContent>
      <Stack spacing="16px">
        {airlineCodeList?.map((airline: any) => (
          <Link
            sx={{
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '20px',
              textDecoration: 'none',
              color: `${style.primary.blue}`,
              textDecorationLine: 'underline',
              textDecorationColor: `${style.primary.blue}`,
            }}
            href={genLinkSeoForVexPage(showToOnly ? toOnlyLinkSeo(airline.slug) : fromLinkSeo(airline.slug))}
            key={airline.name}
          >
            {showToOnly ? toOnlyText(airline.name) : fromText(airline.name)}
          </Link>
        ))}
      </Stack>
    </>
  );
}
